export const relationshipOptions = [
  'Spouse',
  'Son',
  'Daughter',
  'Parent',
  'Sibling',
  'Other',
]
